import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import {OpenAIModelConfig} from '../../openAI/openAI.models';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import getLLMModel from './getLLMModel';
import {OpenAIModel} from '../../openAI/openAI.enums';

function getDefaultLLMModel(): OpenAIModelConfig {
  const isGtp5_2Enabled = isFlagEnabled(FeatureFlagKey.EnableGpt5_2);

  const defaultModel = isGtp5_2Enabled
    ? getLLMModel(OpenAIModel.Gpt5_2)
    : getLLMModel(OpenAIModel.Gpt5_1);

  return defaultModel;
}

export default getDefaultLLMModel;
